// Modal-instance carryover for the task thread. Refusal, queue, and stream state remain local to one open
// Task. Only the bounded draft and an exact uncertain PendingTaskRequest seed from page memory.

import { useRef } from 'react';
import type { ComposerStash } from '../surfaces/useTaskThread.ts';
import type { TaskComposerRetention } from '../surfaces/task-request-identity.ts';

export interface TaskThreadCarryover {
  readonly streamFailureFence: React.MutableRefObject<string | null>;
  readonly composerStash: React.MutableRefObject<ComposerStash>;
}

function composerStash(retention: TaskComposerRetention | null): ComposerStash {
  return {
    draft: retention?.draft ?? '',
    note: null,
    queuedRun: null,
    pendingRequest: retention?.pendingRequest ?? null,
  };
}

/** Keep reload-sensitive state above SurfaceFrame; the Task-keyed modal remount resets the full instance. */
export function useTaskThreadCarryover(
  retention: TaskComposerRetention | null,
): TaskThreadCarryover {
  const streamFailureFence = useRef<string | null>(null);
  const stash = useRef<ComposerStash>(composerStash(retention));
  return { streamFailureFence, composerStash: stash };
}
